import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Modal,
  ButtonGroup,
  ToggleButton,
  Spinner,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WebService from "../../Services/WebService";
import LoginImg from "../../assets/images/vfr.jpg";
import Vfrcertificate from "../../assets/images/vfr-certificate.jpg";
import { toast } from "react-toastify";

const SubscriptionPlans: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("vfr");
  const [plans, setPlans] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState<any>(null);
  const handleClose = () => setIsSuccessModalOpen(false);
  const handleOpen = () => setIsSuccessModalOpen(true);
  const [couponData, setCouponData] = useState<any>({});
  useEffect(() => {
    fetchSubscriptionPlans();
    fetchUserActivePlan();
  }, []);

  const fetchSubscriptionPlans = async () => {
    try {
      setLoading(true);
      const response: any = await WebService.getAPI({
        action: `/subscriptions/list`,
      });

      if (response?.list && Array.isArray(response.list)) {
        setPlans(response.list);
      } else {
        setPlans([]);
      }
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
      toast.error("Failed to fetch subscription plans");
      setPlans([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchUserActivePlan = async () => {
    try {
      const res: any = await WebService.postAPI({
        action: `/users/subscribed-plans`,
        body: null,
      });
      const active = res.list?.find((item: any) => item.status === "ACTIVE");
      setActiveSubscription(active || null);
    } catch (err) {
      console.error("Error fetching user active plan:", err);
    }
  };
  const applyCoupon = async (planUuid: any) => {
    const data = couponData[planUuid];

    try {
      const res: any = await WebService.postAPI({
        action: "/apply-coupon",
        body: {
          code: data?.coupon,
          subscription_uuid: planUuid,
        },
      });

      setCouponData((prev: any) => ({
        ...prev,
        [planUuid]: {
          ...prev[planUuid],
          discount: res.discount,
          finalPrice: res.final_price,
          error: "",
        },
      }));
    } catch (err) {
      setCouponData((prev: any) => ({
        ...prev,
        [planUuid]: {
          ...prev[planUuid],
          error: "Invalid coupon",
          discount: 0,
          finalPrice: 0,
        },
      }));
    }
  };
  // ✅ Filter plans dynamically by active tab (vfr/ifr)
  const filteredPlans = plans.filter((plan) =>
    activeTab === "vfr" ? plan.is_vfr === 1 : plan.is_ifr === 1,
  );

  const handleSubscribe = (plan: any) => {
    const data = couponData[plan.uuid];

    navigate(`/buy`, {
      state: {
        plan,
        coupon_code: data?.coupon || null,
      },
    });
  };

  return (
    <Container className="my-5">
      {/* Back Button */}
      <div className="d-flex align-items-center mb-4">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="btn btn-link text-decoration-none text-dark d-flex align-items-center p-0"
          style={{ fontSize: "16px" }}
        >
          <span style={{ fontSize: "20px", marginRight: "5px" }}>←</span> Back
        </button>
      </div>

      <center>
        <h5 className="fw-bold">Subscription Plans</h5>
        <p className="text-muted mb-4">
          Choose the subscription plan that fits your business needs.
        </p>

        {/* Toggle Buttons */}
        <ButtonGroup>
          <ToggleButton
            id="vfr-plan"
            type="radio"
            variant={activeTab === "vfr" ? "info" : "outline-secondary"}
            name="options"
            value="vfr"
            checked={activeTab === "vfr"}
            onClick={() => setActiveTab("vfr")}
            style={{
              backgroundColor: activeTab === "vfr" ? "#00A899" : "",
              color: activeTab === "vfr" ? "white" : "",
              border: "1px solid #ccc",
            }}
          >
            VFR Plan
          </ToggleButton>
          <ToggleButton
            id="ifr-plan"
            type="radio"
            variant={activeTab === "ifr" ? "info" : "outline-secondary"}
            name="options"
            value="ifr"
            checked={activeTab === "ifr"}
            onClick={() => setActiveTab("ifr")}
            style={{
              backgroundColor: activeTab === "ifr" ? "#00A899" : "",
              color: activeTab === "ifr" ? "white" : "",
              border: "1px solid #ccc",
            }}
          >
            IFR Plan
          </ToggleButton>
        </ButtonGroup>
      </center>

      {/* Loader */}
      {loading && (
        <div className="text-center mt-5">
          <Spinner animation="border" variant="info" />
          <p className="text-muted mt-2">Loading subscription plans...</p>
        </div>
      )}

      {/* Cards */}
      {!loading && (
        <div className="mt-4">
          <Row className="g-4 mt-2">
            {filteredPlans.length > 0 ? (
              filteredPlans.map((plan: any, index: number) => (
                <Col md={4} key={index}>
                  <Card className="h-100 border-0 rounded-3 position-relative shadow-sm">
                    <Card.Body className="text-start card p-4">
                      {/* Badge */}
                      {plan.with_certificate === 1 && (
                        <Badge
                          bg="warning"
                          text="white"
                          className="position-absolute top-0 end-0 mt-3 me-3 rounded-pill px-3 py-2"
                        >
                          Certificate Included
                        </Badge>
                      )}

                      {/* Top Section */}
                      <div className="d-flex gap-3 align-items-center">
                        <div>
                          <img
                            src={
                              plan.with_certificate === 1
                                ? Vfrcertificate
                                : LoginImg
                            }
                            alt={plan.name}
                            style={{
                              height: "75px",
                              borderRadius: "10px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        {/* <div>
                          <Card.Title className="fw-bold mb-1">
                            {plan.name}
                          </Card.Title>
                          <h5 className="text-info fw-bold mb-0">
                            {plan.price_with_currency}
                            <small className="text-dark fw-normal">
                              &nbsp;/ {plan.duration_format}
                            </small>
                          </h5>
                          <small className="text-muted d-block">
                            billed annually (excluding Professional Services)
                          </small>
                        </div> */}

                        {couponData[plan.uuid]?.finalPrice ? (
                          <>
                            {/* Discounted Price */}
                            <h5 className="text-success fw-bold mb-0">
                              €{couponData[plan.uuid].finalPrice}
                              <small className="text-dark fw-normal">
                                &nbsp;/ {plan.duration_format}
                              </small>
                            </h5>

                            {/* Original Price */}
                            <small
                              style={{
                                textDecoration: "line-through",
                                color: "gray",
                              }}
                            >
                              {plan.price_with_currency}
                            </small>
                            <small className="text-muted d-block">
                              billed annually (excluding Professional Services)
                            </small>
                          </>
                        ) : (
                          <>
                            <h5 className="text-info fw-bold mb-0">
                              {plan.price_with_currency}
                              <small className="text-dark fw-normal">
                                &nbsp;/ {plan.duration_format}
                              </small>
                            </h5>
                            <small className="text-muted d-block">
                              billed annually (excluding Professional Services)
                            </small>
                          </>
                        )}
                      </div>

                      {/* Subscribe Button */}
                      <Button
                        onClick={() => handleSubscribe(plan)}
                        variant="info"
                        className="w-100 text-white mt-3"
                        style={{
                          backgroundColor: "#00A899",
                          border: "none",
                          fontWeight: "600",
                        }}
                      >
                        {plan.button_title || "Subscribe"}
                      </Button>

                      {/* Coupon Section */}
                      <div className="mt-2">
                        {!couponData[plan.uuid]?.show && (
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#00A899",
                              fontSize: "14px",
                            }}
                            onClick={() =>
                              setCouponData((prev: any) => ({
                                ...prev,
                                [plan.uuid]: { ...prev[plan.uuid], show: true },
                              }))
                            }
                          >
                            Apply Coupon 🎁
                          </span>
                        )}

                        {couponData[plan.uuid]?.show && (
                          <>
                            <div className="d-flex mt-2">
                              <input
                                type="text"
                                placeholder="Enter code"
                                className="form-control me-2"
                                value={couponData[plan.uuid]?.coupon || ""}
                                onChange={(e) =>
                                  setCouponData((prev: any) => ({
                                    ...prev,
                                    [plan.uuid]: {
                                      ...prev[plan.uuid],
                                      coupon: e.target.value,
                                    },
                                  }))
                                }
                              />

                              <button
                                className="btn"
                                style={{
                                  background: "#00a899",
                                }}
                                onClick={() => applyCoupon(plan.uuid)}
                              >
                                Apply
                              </button>
                            </div>

                            {/* Error */}
                            {couponData[plan.uuid]?.error && (
                              <small className="text-danger">
                                {couponData[plan.uuid].error}
                              </small>
                            )}

                            {/* Discount */}
                            {couponData[plan.uuid]?.discount > 0 && (
                              <div className="mt-2">
                                <small>
                                  Original: {plan.price_with_currency}
                                </small>
                                <br />
                                <small className="text-success">
                                  Discount: -€{couponData[plan.uuid].discount}
                                </small>
                                <br />
                                <strong>
                                  Final: €{couponData[plan.uuid].finalPrice}
                                </strong>
                              </div>
                            )}
                          </>
                        )}
                      </div>

                      {/* Description */}
                      {plan.description && (
                        <Card.Text
                          className="mt-3 text-dark"
                          style={{ fontSize: "14px" }}
                        >
                          {plan.description}
                        </Card.Text>
                      )}

                      {/* Features */}
                      {plan.features && plan.features.length > 0 && (
                        <>
                          <h6 className="fw-bold mt-3 mb-2">
                            Features Included:
                          </h6>
                          <ul
                            className="mt-2 ps-3"
                            style={{ fontSize: "13px" }}
                          >
                            {plan.features.map((f: any) => (
                              <li key={f.id}>{f.title}</li>
                            ))}
                          </ul>
                        </>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <p className="text-center text-muted">
                No subscription plans found for {activeTab.toUpperCase()}.
              </p>
            )}
          </Row>
        </div>
      )}

      {/* ✅ Success Modal */}
      <Modal show={isSuccessModalOpen} onHide={handleClose} centered>
        <Modal.Body className="text-center p-4">
          <svg
            width="90"
            height="90"
            viewBox="0 0 90 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.2"
              d="M45 3C68.1798 3 87 21.8202 87 45C87 68.1798 68.1798 87 45 87C21.8202 87 3 68.1798 3 45C3 21.8202 21.8202 3 45 3Z"
              fill="#24A25D"
            />
            <path
              d="M45 18C59.9013 18 72 30.0987 72 45C72 59.9013 59.9013 72 45 72C30.0987 72 18 59.9013 18 45C18 30.0987 30.0987 18 45 18Z"
              fill="#24A25D"
            />
            <path
              d="M34.7852 47.6038L40.5096 53.0645L56.2905 38.0107"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <h5 className="fw-bold mt-3">Subscribed Successfully!</h5>
          <p className="text-muted">
            You have successfully subscribed to this plan. Let’s get started!
          </p>
          <Button
            className="w-100 text-white mt-3 btn btn-info"
            onClick={() => (window.location.href = "/dashboard")}
            style={{
              backgroundColor: "#00A899",
              border: "none",
              padding: "10px 30px",
            }}
          >
            Homepage
          </Button>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default SubscriptionPlans;
